// Author Lin
// Date 2021-03-17 11:35:21

class SithMesMstMilestone {
constructor({
        id = null,
        machineTypeId = '',
        name = '',
        code = '',
        remark = ''}
= {}) {
    this.id = id;
    this.machineTypeId = machineTypeId;
    this.name = name;
    this.code = code;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstMilestone();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'machineTypeId',
        label: 'label.sith.mst.sithMesMstMilestone.grid.machineTypeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'machineName',
        label: 'label.sith.mst.sithMesMstMilestone.grid.machineName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstMilestone.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstMilestone.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMilestone.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    machineTypeIdFilter : "",
    nameFilter : "",
    codeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'machineTypeIdFilter',
        label: 'label.sith.mst.sithMesMstMilestone.filter.machineTypeId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstMilestone.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.sith.mst.sithMesMstMilestone.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'machineTypeId',
        label: 'label.sith.mst.sithMesMstMilestone.entity.machineTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'sithMesMstMachineType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstMilestone.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstMilestone.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMilestone.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstMilestone, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
